/**
 * First-class reservations (Phase F).
 */

import { enc, ocppRequest } from './ocppApi';
import type {
  CancelOcppReservationResponse,
  CreateOcppReservationBody,
  CreateOcppReservationResponse,
  ListOcppReservationsResponse,
} from '../models';

export const listReservations = (chargerId: string) =>
  ocppRequest<ListOcppReservationsResponse>({
    method: 'GET',
    path: `reservations/${enc(chargerId)}`,
  });

export const createReservation = (chargerId: string, body: CreateOcppReservationBody) =>
  ocppRequest<CreateOcppReservationResponse>({
    method: 'POST',
    path: `reservations/${enc(chargerId)}`,
    body,
  });

export const cancelReservation = (chargerId: string, reservationId: number) =>
  ocppRequest<CancelOcppReservationResponse>({
    method: 'DELETE',
    path: `reservations/${enc(chargerId)}/${enc(reservationId)}`,
  });
